import { IMakeCancellablePromise, makeCancellablePromise } from '@gem/utils';

import { storageSessionCredentials } from '../../storage';
import { remoteStorageConfiguration } from '../configuration';

let loadRemoteStorageCredentialsPromise: IMakeCancellablePromise<boolean> | null = null;

async function makeLoadRemoteStorageCredentials(): Promise<boolean> {
  if (!remoteStorageConfiguration.getCredentialsRequest) {
    storageSessionCredentials.remove();
    return false;
  }
  try {
    const credentials = await remoteStorageConfiguration.getCredentialsRequest();
    if (!credentials) {
      storageSessionCredentials.remove();
      return false;
    }
    storageSessionCredentials.set(credentials);
    return true;
  } catch {
    storageSessionCredentials.remove();
    return false;
  }
}

export function loadRemoteStorageCredentials(): Promise<boolean> {
  if (!loadRemoteStorageCredentialsPromise) {
    loadRemoteStorageCredentialsPromise = makeCancellablePromise(
      makeLoadRemoteStorageCredentials().finally(() => {
        loadRemoteStorageCredentialsPromise = null;
      })
    );
  }

  return loadRemoteStorageCredentialsPromise.promise;
}

export function cancelLoadRemoteStorageCredentials(): void {
  loadRemoteStorageCredentialsPromise?.cancel();
}

export async function checkIsStorageCredentialsLoaded(): Promise<boolean> {
  if (loadRemoteStorageCredentialsPromise === null) {
    return true;
  }
  await loadRemoteStorageCredentialsPromise.promise;
  return true;
}
